module.exports = __webpack_public_path__ + "static/media/frames-26.0ede50c3.jpg";